import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter as Router, Route} from 'react-router-dom';
import {I18nextProvider} from 'react-i18next';
import i18n from './i18n';
import './styles/app.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

require('bootstrap');

const startApp = () => {
    ReactDOM.render((

            <I18nextProvider i18n={i18n}>
                <Router>
                    <Route component={App}/>
                </Router>
            </I18nextProvider>
        ),
        document.getElementById('root')
    );
    registerServiceWorker();
};


function getPermission(permissions, permission) {
    return new Promise(function(resolve, reject) {
        permissions.checkPermission(permission, function(status) {
            if (!status.hasPermission) {
                permissions.requestPermission(permission, function(status){
                    if (!status.hasPermission) {
                        //console.warn("Permission not granted");
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                  }, function() {
                    console.warn('error getting permission')
                    reject();
                  })
            } else {
                resolve(true);
            }
        }, function() {
            console.warn('error checking permission')
            reject();
        });
    });
}

function startCordovaApp()
{
    startApp();
    if (window.cordova && window.cordova.plugins && window.cordova.plugins.permissions) {
        var permissions = window.cordova.plugins.permissions;
        getPermission(permissions, permissions.ACCESS_FINE_LOCATION)
        .then(function(status){
            // move this to after camera-button-click and before camera render?
            getPermission(permissions, permissions.CAMERA)
            .then(function(status){
            })
            .catch(function(){
                console.waren("Camera permission: error getting permission")
            })
        })
        .catch(function() {
            console.warn("Geolocation permission: error getting permission");
        });
    }
/*

        permissions.checkPermission(permissions.CAMERA, function(status){
          if (!status.hasPermission) {
            // permission not yet given, request permission
            permissions.requestPermission(permissions.CAMERA, function(status){
              if (!status.hasPermission) {
                console.warn("Permission not granted");
              }
            }, function() {
              console.warn('error getting camera permission')
            })
          }
        });
    }
*/
}

if(window.cordova) {
    document.addEventListener('deviceready', startCordovaApp, false);
} else {
    startApp();
}



// WEBPACK FOOTER //
// ./src/index.js